import AccountService from "../AccountService";
import UseFetchRequest from "../../fetch/hooks/UseFetchRequest";

const useAccounts = () => {
    const [fetch] = UseFetchRequest.useFetchRequest(() => AccountService.getAccounts());
    return fetch;
};

export default useAccounts;
